import React from 'react';
import { cn } from './cn';

const Progress = React.forwardRef(({ className, value, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('relative h-4 w-full overflow-hidden rounded-full bg-succession-bg-secondary', className)}
    role="progressbar"
    aria-valuenow={value || 0}
    aria-valuemin={0}
    aria-valuemax={100}
    {...props}
  >
    <div
      className="h-full w-full flex-1 bg-succession-primary transition-all duration-300"
      style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
    />
  </div>
));

Progress.displayName = 'Progress';

export { Progress };
